<kendo-grid
  #grid="kendoGrid"
  id="productsGrid"
  [data]="!filtering ? gridData : gridView"
  [reorderable]="true"
  [resizable]="true"
  [selectable]="true"
  [(filter)]="state.filter"
  [sortable]="{ allowUnsort: filtering, mode: 'multiple' }"
  [filterable]="filtering"
  [pageable]="paging ? { buttonCount: 5, info: true, type: 'numeric', pageSizes: [5, 10, 15, 20], previousNext: true } : false"
  [pageSize]="state.take"
  [skip]="state.skip"
  [kendoGridSelectBy]="SelectById"
  [selectable]="isMulti"
  [selectedKeys]="mySelection"
  (dataStateChange)="dataStateChange($event)"
  (selectedKeysChange)="onSelectedKeysChange($event)"
  (selectionChange)="onGridSelectionChange($event)"
  (remove)="removeHandler($event)"
  (pageChange)="pageChange($event)"
  (cellClick)="cellClickHandler($event)"
  (save)="saveCurrent()"
  [selectedKeys]="mySelection"
  [navigable]="true"
  [style.height.vmin]="height">
  <ng-template kendoGridToolbarTemplate *ngIf="!hideToolber">
    <ssg-button *ngIf="isAdd" (click)="addHandler()" tooltip="ایجاد رکورد جدید" class="editbtn" icon="icon-add-o"></ssg-button>

    <ssg-button *ngIf="formGroup" (click)="cancelHandler()" class="editbtn cancelbtn" icon="icon-cancel-24px" tooltip="انصراف"></ssg-button>

    <ssg-button
      *ngIf="paging"
      (click)="clearFilter()"
      class="btnstyle"
      data-tooltip="top"
      tooltip="حذف فیلتر"
      icon="icon-filter-off-outline"></ssg-button>

    <ng-content select="#toolbar-button"></ng-content>

    <span *ngIf="formTitle" style="font-size: 1rem">{{ formTitle }}</span>
    <span *ngIf="formTitle2" style="font-size: 1rem; margin-right: auto; display: inline-block">{{ formTitle2 }}</span>
  </ng-template>
  <kendo-grid-checkbox-column showSelectAll="true" [width]="60" [columnMenu]="false" minResizableWidth="60" *ngIf="isMulti">
    <ng-template kendoGridHeaderTemplate>
      <input
        class="k-checkbox"
        id="selectAllCheckboxId"
        kendoGridSelectAllCheckbox
        [state]="selectAllState"
        (selectAllChange)="onSelectAllChange($event)" />
      <label class="k-checkbox-label" for="selectAllCheckboxId"></label>
    </ng-template>
  </kendo-grid-checkbox-column>
  <kendo-grid-command-column *ngIf="isDelete || isEdit" title="عملیات" [columnMenu]="false" width="65" minResizableWidth="65">
    <ng-template kendoGridCellTemplate>
      <button *ngIf="isDelete" kendoGridRemoveCommand icon="delete" title="حذف"></button>
      <button kendoGridSaveCommand [disabled]="formGroup?.invalid" icon="save" title="{{ isNew ? 'جدید' : 'تغییر' }}"></button>
    </ng-template>
  </kendo-grid-command-column>

  <kendo-grid-column
    *ngFor="let column of columns"
    field="{{ column.name }}"
    title="{{ column.label }}"
    format="{{ column.format }}"
    [width]="column.columnWidth"
    [minResizableWidth]="column.columnWidth * 0.25"
    [hidden]="!column.listVisible"
    [editable]="!column.disabled"
    editor="{{ column.textType == 'checkbox' ? 'boolean' : column.textType == 'number' ? 'numeric' : column.textType == 'date' ? 'date' : 'text' }}"
    filter="{{ 'text' }}">
    <ng-template *ngIf="column.inputMask" kendoGridCellTemplate let-dataItem>
      {{ getMaskedAmount(dataItem[column.name], column.inputMask) }}
    </ng-template>
    <ng-template *ngIf="column.inputMask && formGroup" kendoGridEditTemplate let-dataItem>
      <input [formControl]="formGroup.get(column.name)" type="text" name="{{ column.name }}" [SsgMask]="column.inputMask" />
    </ng-template>
    <ng-template *ngIf="column.apiName" kendoGridCellTemplate let-dataItem>
      {{
        getItemDisplayById(
          column.apiName,
          column.systemName,
          dataItem[column.name],
          column.displayMember,
          column.valueMember,
          column.name,
          dataItem,
          column.IsMultiSelect
        )
      }}
    </ng-template>
    <ng-template *ngIf="column.textType === 'date'" kendoGridCellTemplate let-dataItem>
      {{ getDateValue(dataItem[column.name]) }}
    </ng-template>
    <ng-template
      *ngIf="column.apiName && hasMultiColumns(column.columnsName) && !column.isSelector"
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew">
      <st-lookup
        name="{{ column.name }}"
        [idName]="getIdName(column?.name)"
        [group]="formGroup"
        apiName="{{ column.apiName }}"
        textFieldName="{{ column.displayMember }}"
        valueFieldName="{{ column.custom ? column.displayMember : column.valueMember }}"
        [defaultHeight]="25"
        (onRowsSelected)="onRowsSelected($event, column.name, column.valueMember, column.displayMember, column.custom)"
        [isMulti]="column?.isMulti"
        [isPaging]="true"
        tabindex="0"
        (onRowSelected)="selectionChange($event, column.name, column.valueMember, column.displayMember, dataItem, column.custom)"
        textColumnsName="{{ column.columnsName }}"
        [disabled]="false">
      </st-lookup>
    </ng-template>
    <ng-template
      *ngIf="column.apiName && column.parentIdName"
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew">
      <tree-lookup
        name="{{ column.name }}"
        [group]="formGroup"
        apiName="{{ column.apiName }}"
        textFieldName="{{ column.displayMember }}"
        valueFieldName="{{ column.valueMember }}"
        [defaultHeight]="30"
        [isPaging]="true"
        tabindex="0"
        [checkedKeys]="getcheckedKeys(column.name)"
        [parentIdName]="column?.parentIdName"
        [filterKey]="column?.filterKey"
        (valueChangeByApiName)="selectionChange($event, column.name, column.valueMember, column.displayMember, dataItem)"
        textColumnsName="{{ column.columnsName }}"
        [disabled]="false">
      </tree-lookup>
    </ng-template>
    <ng-template *ngIf="column.textType === 'date'" kendoGridEditTemplate let-dataItem>
      <date-picker
        id="dp{{ column.name }}"
        [defaultHeight]="30"
        [group]="formGroup"
        name="{{ column.name }}"
        label="{{ column.label }}"
        textType="{{ column.textType }}">
      </date-picker>
    </ng-template>
    <ng-template
      *ngIf="column.apiName && !hasMultiColumns(column.columnsName) && !column.parentIdName && !column.IsMultiSelect && !column.isSelector"
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew">
      <kendo-dropdownlist
        #ddl="popupAnchor"
        popupAnchor
        #DropDown
        [defaultItem]="{ Id: null, Title: 'تهی کردن اطلاعات' }"
        [data]="GetLookupData(column.apiName)"
        textField="{{ column.displayMember }}"
        valueField="{{ column.valueMember }}"
        (selectionChange)="selectionChange($event, column.name, column.valueMember, column.displayMember, dataItem)"
        [valuePrimitive]="true"
        [formControl]="formGroup.get(column.name)"
        (open)="onOpen(DropDown)">
      </kendo-dropdownlist>
      <kendo-popup
        [anchor]="ddl.element"
        *ngIf="formGroup.get(column.name).invalid && !(isNew && formGroup.get(column.name).untouched)"
        popupClass="k-widget k-tooltip k-tooltip-validation k-invalid-msg">
        <span class="k-icon k-i-warning"></span>
        {{ column.label }} الزامی است
      </kendo-popup>
    </ng-template>
    <ng-template
      *ngIf="column?.apiName || column.isSelector"
      kendoGridEditTemplate
      let-dataItem="dataItem"
      let-formGroup="formGroup"
      let-isNew="isNew">
      <ssg-select
        name="{{ column?.name }}"
        [multiple]="true"
        appendTo="body"
        [disabled]="column?.disabled"
        [group]="formGroup"
        apiName="{{ column.apiName }}"
        [required]="column?.required"
        [dataList]="column?.dataList"
        [multiple]="column?.IsMultiSelect"
        (valueChange)="multiSelectValueChange($event, column, dataItem)"
        (CompleteData)="CompleteData.emit($event)"
        (valueChangeByApiName)="valueChangeByApiName.emit($event)"
        systemName="{{ column?.systemName }}"
        category="{{ column?.category }}"
        textFieldName="{{ column?.displayMember }}"
        valueFieldName="{{ column?.valueMember }}">
      </ssg-select>
    </ng-template>
    <ng-template *ngIf="column.textType == 'checkbox'" kendoGridCellTemplate let-dataItem>
      <input type="checkbox" class="k-checkbox" [checked]="dataItem[column.name]" tabindex="0" [disabled]="true" />
    </ng-template>
    <ng-template *ngIf="hasAggregate(column.name)" kendoGridFooterTemplate> جمع:{{ getColumnAggregates(column.name) | number }} </ng-template>
    <ng-template *ngIf="column.textType !== 'date' && !column.apiName" kendoGridGroupHeaderTemplate let-value="value">
      {{ getValue(value) }}
    </ng-template>
  </kendo-grid-column>
</kendo-grid>
